import styles from './styles.module.css'
import { memo } from 'react'

const CategoriesItem = ({ isCurrent, label, onClick, length, isFirst }) => {
  // Calculate dynamic classes based on props
  const getItemClasses = () => {
    let classes = [styles.categoriesItemStyle]

    if (isCurrent) {
      classes.push(styles.isCurrent)

      // Handle first child border radius logic
      if (isFirst && length < 5) {
        classes.push(styles.firstChildShortList)
      }
    }

    // Handle length-based styling for bottom border
    if (length <= 4) {
      classes.push(styles.lengthLte4)
    } else {
      classes.push(styles.lengthGt4)
    }

    return classes.join(' ')
  }

  // Calculate dynamic inline styles for complex border logic
  const getItemStyle = () => {
    const itemStyle = {}

    // Handle complex bottom border logic for items in multi-row layouts
    if (length > 4) {
      const lastRowStart = 3 * Math.floor(length / 4) + 1 + Math.floor((length - 1) / 4)
      // This complex calculation matches the styled-components logic
      // We'll use CSS custom properties or additional logic if needed
    }

    return itemStyle
  }

  return (
    <div className={getItemClasses()} onClick={onClick} style={getItemStyle()}>
      {label}
    </div>
  )
}

export default memo(CategoriesItem)
